<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M13.518 14.739a1.254 1.254 0 0 1-.238.747c-.055.063-.094.094-.116.094H3.958c-.022 0-.06-.031-.116-.094a1.258 1.258 0 0 1-.238-.747V4.249h9.914v10.49zM6.625 1.538a.312.312 0 0 1 .188-.122h3.507a.313.313 0 0 1 .188.122l.532 1.294H6.082zm9.626 1.394a.345.345 0 0 0-.254-.1h-3.42L11.804.986c-.11-.273-.31-.506-.597-.697C10.918.096 10.626 0 10.33 0h-3.54c-.296 0-.587.096-.875.288-.287.191-.487.424-.597.697l-.775 1.848H1.125a.345.345 0 0 0-.255.1.345.345 0 0 0-.099.254v.708c0 .103.033.188.1.254.066.067.15.1.254.1h1.062v10.534c0 .613.174 1.134.52 1.566.347.431.764.647 1.25.647h9.207c.487 0 .904-.223 1.25-.67.347-.446.52-.975.52-1.587V4.249h1.063a.344.344 0 0 0 .254-.1.345.345 0 0 0 .1-.254v-.708a.345.345 0 0 0-.1-.255z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M5.374 13.455h.708a.344.344 0 0 0 .255-.1.346.346 0 0 0 .1-.254V6.727a.345.345 0 0 0-.1-.254.345.345 0 0 0-.255-.1h-.708a.345.345 0 0 0-.254.1.345.345 0 0 0-.1.254v6.374c0 .104.033.188.1.255.066.066.15.1.254.1z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M8.207 13.455h.708a.344.344 0 0 0 .254-.1.344.344 0 0 0 .1-.254V6.727a.344.344 0 0 0-.1-.254.345.345 0 0 0-.254-.1h-.708a.345.345 0 0 0-.255.1.345.345 0 0 0-.1.254v6.374c0 .104.034.188.1.255.067.066.152.1.255.1z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M11.04 13.455h.708a.345.345 0 0 0 .254-.1.345.345 0 0 0 .1-.254V6.727a.345.345 0 0 0-.1-.254.345.345 0 0 0-.254-.1h-.708a.345.345 0 0 0-.255.1.345.345 0 0 0-.1.254v6.374c0 .104.034.188.1.255.067.066.151.1.255.1z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3b334a',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>
